import { call, put } from 'typed-redux-saga/macro';

import type { GetActionByType } from 'Lib/reduxType';

import { setDeeplinkIntroPriceInfo } from 'Store/user/actions';
import { DEEPLINK_TYPE_CAMPAIGN } from 'Store/user/constants';

import { VERIFY_CAMPAIGN_DEEPLINK_ROUTE, VERIFY_CONFIRMATION_DEEPLINK_ROUTE } from '../constants';
import { verifyConfirmationDeeplinkRouteSaga } from './confirm';

export function* verifyCampaignDeeplinkRouteSaga(
  action: GetActionByType<typeof VERIFY_CAMPAIGN_DEEPLINK_ROUTE>
) {
  const { campaignInfo } = action.payload;
  if (campaignInfo.includes('intro')) {
    // campaign info format: intro_t{termLength}_d{discountPercentage}
    const introPriceInfo = campaignInfo.split('_');
    const introPriceTerm = introPriceInfo[1] && parseInt(introPriceInfo[1].substring(1), 10);
    const introPriceDiscount = introPriceInfo[2] && parseInt(introPriceInfo[2].substring(1), 10);
    yield* put(setDeeplinkIntroPriceInfo({ term: introPriceTerm, discount: introPriceDiscount }));
  }
  const { payload } = action;

  yield* call(verifyConfirmationDeeplinkRouteSaga, {
    type: VERIFY_CONFIRMATION_DEEPLINK_ROUTE,
    payload: {
      ...payload,
      type: DEEPLINK_TYPE_CAMPAIGN,
    },
  });
}
